var map = {
	"./translation-data_de.js": "./utils/translation-data_de.js",
	"./translation-data_en.js": "./utils/translation-data_en.js",
	"./translation-data_es.js": "./utils/translation-data_es.js",
	"./translation-data_fr.js": "./utils/translation-data_fr.js",
	"./translation-data_jp.js": "./utils/translation-data_jp.js",
	"./translation-data_no.js": "./utils/translation-data_no.js",
	"./translation-data_zh.js": "./utils/translation-data_zh.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./utils sync recursive ^\\.\\/translation\\-data_.*\\.js$";